import onScan from "onscan.js";

/**
 * Extracts the character of a `keydown` event for onScan.js.
 *
 * The library's own decoder (`onScan.decodeKeyEvent`) filters on `keyCode`,
 * which describes the *physical* key mapped through a US layout — not the
 * character the active layout produced. Everything outside 48-90 and 96-111 is
 * dropped, so the very same `-` survives when it comes from the AZERTY `6` key
 * (keyCode 54) and vanishes when a scanner emits it from the US Minus key
 * (keyCode 189).
 *
 * Logistic codes look like `#1458023-R1`: a warehouse scanning with a
 * US-configured reader was sending `#1458023R1`, which matches no return at
 * all. The default decoder also returns `event.key` verbatim once the keyCode
 * falls inside its window, which is how dead keys injected the literal string
 * "Dead" into scanned payloads.
 *
 * `event.key` already carries the character the layout produced, so we take it
 * whenever it is a single character and only fall back to the library for what
 * it decodes specially. Named keys (`Shift`, `Enter`, `Dead`, ...) are longer
 * than one character and are therefore ignored.
 */
export function decodeScanKey(event: KeyboardEvent): string {
  if (typeof event.key === "string" && event.key.length === 1) {
    return event.key;
  }

  return onScan.decodeKeyEvent(event);
}
